import React, { Component } from 'react';

class ServicesSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      servicesData: [
        {
          id: 1,
          icon: '../images/ser1.svg',
          title: '24/7 VIDEO MONITORING & INCIDENT RESPONSE',
          description: 'AI-driven live video surveillance that ensures instant detection, verification, and response—anytime, anywhere.'
        },
        {
          id: 2,
          icon: '../images/ser2.svg', 
          title: 'REMOTE CONCIERGE SERVICES',
          description: 'Modern virtual concierge services that manage visitors, incidents, and building operations remotely and efficiently.'
        },
        {
          id: 3,
          icon: '../images/ser3.svg',
          title: 'REMOTE ACCESS MANAGEMENT',
          description: 'Secure, real-time access control with remote oversight and video verification from anywhere.'
        },
        {
          id: 4,
          icon: '../images/ser4.svg',
          title: 'TIME LAPSE VIDEOS',
          description: 'High-quality time-lapse videos that capture and showcase your project progress for tracking and promotion.'
        }
    
      ]
    };
  }

  renderServiceCard = (service) => {
    return (
      <div key={service.id} className="col-xl-3 col-lg-6 col-md-6 mb-4">
        <div className="service-card">
          <div className="service-icon p-3 mb-3" style={{width: 'fit-content'}}>
            <img alt={service.title.toLowerCase()} src={service.icon} />
          </div>
          <h5 className="fw-bold mb-3">{service.title}</h5>
          <p className="text-muted">
            {service.description}
          </p>
          <div className="triangle-bottomright-dark"></div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="services-section bg-dark text-white py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <div className="d-flex justify-content-center align-items-center mb-3">
                <div className="bg-white rounded-circle p-2 me-3">
                  <i className="fas fa-shield-alt text-dark"></i>
                </div>
                <span className="text-uppercase text-white small-upper-text">SOLUTIONS</span>
              </div>
              <h2 className="display-5 fw-bold mb-4">OUR REMOTE SECURITY SOLUTIONS</h2>
              <p className="lead text-muted mx-auto" style={{maxWidth: '800px'}}>
                At Sterling Surveillance Technologies Ltd., we specialize in transforming traditional security into intelligent, tech-driven solutions. By integrating advanced live-video monitoring, AI-powered systems, and access management tools, we help clients take full control of their security infrastructure — saving time, reducing costs, and maximizing performance.
Whether you're safeguarding a construction site, managing residential buildings, or overseeing commercial properties, we tailor our remote security solutions to meet your needs and enhance your operational efficiency.
              </p>
            </div>
          </div>
          <div className="row mb-4">
            {this.state.servicesData.map(this.renderServiceCard)}
          </div>
        </div>
      </div>
    );
  }
}

export default ServicesSection;